// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file pages/v1/page.proto (package pages.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file pages/v1/page.proto.
 */
export const file_pages_v1_page: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChNwYWdlcy92MS9wYWdlLnByb3RvEghwYWdlcy52MSK6AQoEUGFnZRIKCgJpZBgBIAEoCRIOCgZkb21haW4YAiABKAkSEQoJc2x1Z19uYW1lGAMgASgJEg8KB2NvZGVfaWQYBCABKAkSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMwoKdXBkYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBAUINCgtfdXBkYXRlZF9hdGIGcHJvdG8z',
    [file_google_protobuf_timestamp]
  )

/**
 * @generated from message pages.v1.Page
 */
export type Page = Message<'pages.v1.Page'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string domain = 2;
   */
  domain: string

  /**
   * @generated from field: string slug_name = 3;
   */
  slugName: string

  /**
   * @generated from field: string code_id = 4;
   */
  codeId: string

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp
}

/**
 * Describes the message pages.v1.Page.
 * Use `create(PageSchema)` to create a new message.
 */
export const PageSchema: GenMessage<Page> = /*@__PURE__*/ messageDesc(file_pages_v1_page, 0)
